module.exports = __webpack_public_path__ + "img/avatar-s-27.dae56edc.jpg";